export default __webpack_public_path__ + "static/media/358.8fe7b264.png";